import './public-path'
import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

let instance = null

/**
 * 认证状态管理
 * 使用 Vue.prototype 共享全局状态
 */
Vue.prototype.$authState = Vue.observable({
  user: null,
  isAuthenticated: false
})

function render(props = {}) {
  const { container } = props

  instance = new Vue({
    router,
    render: h => h(App),
  }).$mount(container ? container.querySelector('#app') : '#app')
}

export async function bootstrap() {
  console.log('[Vue2 Sub-App] Bootstrap')
}

export async function mount(props) {
  console.log('[Vue2 Sub-App] Mount with props:', props)
  
  // 先渲染应用
  render(props)
  
  // 然后监听主应用的全局状态变化
  if (props.onGlobalStateChange) {
    props.onGlobalStateChange((state, prev) => {
      console.log('[Vue2 Sub-App] Global state changed:', { state, prev })
      
      // 更新本地认证状态（显式处理 undefined）
      Vue.prototype.$authState.user = state.user || null
      Vue.prototype.$authState.isAuthenticated = state.isAuthenticated === true
    }, true) // 第二个参数为 true 表示立即执行回调获取当前状态
  }
}

export async function unmount() {
  if (!instance) {
    return
  }

  console.log('[Vue2 Sub-App] Unmount')
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
}

if (!window.__POWERED_BY_QIANKUN__) {
  console.log('[Vue2 Sub-App] Running in standalone mode')
  render()
}
